<template>
  <div class="topup-footer">
    <div class="topup-footer-bottom">
      <div class="topup-footer-copyrights" v-html="$t('component.footer.copyrights', {year: year})"></div>
    </div>
  </div>
</template>

<script>
import { ToolsClass } from '@/common/class/tools.class'

export default {
  name: 'TopupFooter',
  data () {
    return {
      year: ToolsClass.getCurrentYear()
    }
  }
}
</script>

<style src="../assets/scss/footer.scss" lang="scss"></style>
